<template>
  <path
    d="M6.34 7.93018C3.22 11.0502 3.22 16.1202 6.34 19.2402C7.9 20.8002 9.95 21.5802 12 21.5802C14.05 21.5802 16.1 20.8002 17.66 19.2402C20.78 16.1202 20.78 11.0502 17.66 7.93018L12.71 2.98018C12.32 2.59018 11.69 2.59018 11.3 2.98018L6.34 7.93018ZM12 19.5902C10.4 19.5902 8.89 18.9702 7.76 17.8302C6.62 16.6902 6 15.1902 6 13.5902C6 11.9902 6.62 10.4802 7.76 9.35018L12 5.10018V19.5902Z"
  />
</template>
